module.exports = __webpack_public_path__ + "static/media/eye-dark-gray.f4908118.svg";